const
CONNECTION_ARGS = ['first', 'last', 'before', 'after', 'sortKey', 'reverse', 'query', 'namespace'],
TRANSFORMED_SRC_ARGS = ['maxWidth', 'maxHeight', 'crop'];

function formatValue(value) {
    let expr;
    const type = typeof value;
    switch (type) {
        case 'string':
            expr = `"${value}"`;
            break;
        case 'boolean':
            expr = value ? 'true' : 'false';
            break;
        case 'number':
            expr = value.toString();
            break;
        default:
            if (value == null)
                expr = 'null';
            else
                throw new TypeError(`unsupported argument type: ${type}`);
    }
    return expr;
}

function formatArgs(options, names, defaultValues = {}) {
    const pairs = [];
    for (const name of names) {
        let value = options[name];
        if (value == null) {
            value = defaultValues[name];
            if (value == null)
                continue;
        }
        pairs.push([name, value]);
    }
    const parts = [];
    for (const [name, value] of pairs)
        parts.push(`${name}: ${formatValue(value)}`);
    return parts.join(', ');
}

/* transformedSrc property for images. */
const transformedSrc = (params) => 
    `transformedSrc(
        ${formatArgs(params, TRANSFORMED_SRC_ARGS)}
    )`;

/* Single image according to 'spec'. */
const image = (spec = {}) =>
    `image {
        url: ${transformedSrc(spec)},
        altText
    }`;

/* Item images sized according to 'spec'. */
const images = (spec = {}) =>
    `images(
        ${formatArgs(spec, CONNECTION_ARGS, { first: 10 })}
    ) {
        edges {
            node {
                url: ${transformedSrc(spec)},
                altText
            }
        }
    }`;

/* Product collections. */
const collections = (options = {}) =>
    `collections(
        ${formatArgs(options, CONNECTION_ARGS, { first: 10 })}
    ) {
        edges {
            node {
                handle,
                title
            }
        }
    }`;

const productBasic = () =>
    `id,
    handle,
    onlineStoreUrl,
    title,
    description,
    descriptionHtml,
    productType,
    availableForSale,
    priceRange {
        minVariantPrice { amount, currencyCode }
        maxVariantPrice { amount, currencyCode }
    }`;

/* Product variants fragement. */
const variants = (options) => {
    return `variants(
        ${formatArgs(options, CONNECTION_ARGS, { first: 10 })}
    ) {
        edges {
            node {
                id,
                sku,
                title,
                availableForSale,
                price: priceV2 { amount, currencyCode },
                compareAtPrice: compareAtPriceV2 { amount, currencyCode },
                ${options.image ? image(options.image) : ''}
            }
        }
    }`
}

/* Product metafields fragement. */
const metafields = (options) => {
    return ``
}

function productFields(options) {
    const fields = [];
    if (options.basic)
        fields.push(productBasic(options.basic));
    if (options.variants)
        fields.push(variants(options.variants));
    if (options.metafields)
        fields.push(metafields(options.metafields));
    if (options.collections)
        fields.push(collections(options.collections));
    if (options.images)
        fields.push(images(options.images));
    return fields.join('\n');
}

export const productByHandle = (handle, options) =>
    `query {
        product: productByHandle(handle: "${handle}") {
            ${productFields(options)}
        }
    }`;

export const products = (options) =>
    `query {
        products(
            ${formatArgs(options, CONNECTION_ARGS)}
        ) {
            ${productFields(options)}
        }
    }`;
